import { combineReducers } from 'redux';
import authReducer from './authReducer';
import userReducer from './userReducer';
import formReducer from './formReducer';
import dashboardReducer from './dashboardReducer';
import checklistReducer from './checklistReducer'
const rootReducer = combineReducers({
  auth: authReducer,
  users: userReducer,
  forms: formReducer,
  dashboard: dashboardReducer,
  checklist: checklistReducer,
});
export default rootReducer;
